import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type ServiceModel = {
  id: string | number
}

type CPFModel = {
  cpf?: string
}

export const createNewService = () => {
  return new ServicesUseCase('/service', makeAxiosHttpClient())
}
export const changeDemand = (cdService: number) => {
  return new ServicesUseCase(
    '/service/update/demandaObjetivo/' + cdService,
    makeAxiosHttpClient()
  )
}

export const fetchListToService = ({ id }: ServiceModel) => {
  return new ServicesUseCase(`/service/consumer/${id}`, makeAxiosHttpClient())
}

export const fetchListServiceByCPF = ({ cpf }: CPFModel) => {
  return new ServicesUseCase(
    `/service/getConsumerCpf?cpf=${cpf}`,
    makeAxiosHttpClient()
  )
}

export const updateService = (id: number) => {
  return new ServicesUseCase(`/service/update/${id}`, makeAxiosHttpClient())
}

export const deleteService = ({ id }: ServiceModel) => {
  return new ServicesUseCase(`/service/delete/${id}`, makeAxiosHttpClient())
}
